import { mapListedCategoryApiData } from 'connectors/categories/Categories';
import { getFirstImage } from 'connectors/image/Image';
import { mapListedProductConnectionPreviewType, mapListedProductTypes } from 'connectors/products/Products';
import {
    BrandDetailFragmentApi,
    BrandPreviewFragmentApi,
    ListedBrandFragmentApi,
    useBrandsQueryApi,
} from 'graphql/generated';
import { useQueryError } from 'hooks/graphQl/UseQueryError';
import { BrandDetailType, BrandPreviewType, GroupedBrandType, ListedBrandType } from 'types/brand';

export function useBrands(): GroupedBrandType[] | undefined {
    const [{ data, error }] = useBrandsQueryApi();
    useQueryError(error);

    if (data?.brands === undefined) {
        return undefined;
    }

    return data.brands;
}

export const mapBrandDetailData = (apiData: BrandDetailFragmentApi): BrandDetailType => {
    return {
        ...apiData,
        __typename: 'Brand',
        productConnection: mapListedProductConnectionPreviewType(apiData.products),
        image: getFirstImage(apiData.brandImages),
        categories: apiData.categories.map((category) => mapListedCategoryApiData(category)),
    };
};

export const mapBrandPreviewData = (apiData: BrandPreviewFragmentApi, currencyCode: string): BrandPreviewType => {
    return {
        __typename: 'Brand',
        uuid: apiData.uuid,
        name: apiData.name,
        seoH1: apiData.seoH1,
        slug: apiData.slug,
        description: apiData.description,
        image: getFirstImage(apiData.brandImages),
        categories: apiData.promotedCategories.map((category) => mapListedCategoryApiData(category)),
        products: mapListedProductTypes(apiData.products.edges, currencyCode),
        totalProductsCount: apiData.products.totalCount,
    };
};

export const mapListedBrand = (apiData: ListedBrandFragmentApi): ListedBrandType => {
    return {
        ...apiData,
        image: getFirstImage(apiData.images),
    };
};

export const mapListedBrandsApiData = (apiData: ListedBrandFragmentApi[]): ListedBrandType[] => {
    return apiData.map((brand) => mapListedBrand(brand));
};
